import * as Sentry from '@sentry/browser';

export default {
  methods: {
    track_successful_order(order, prices) {
      if (process.env.NODE_ENV === 'development') return

      try {
        this.notify_intercom(order)
      } catch (err) {
        Sentry.addBreadcrumb({
          message: '[CAUGHT] error with intercom analytics (Order)'
        });
        Sentry.captureException(err)
        // console.log(`ERR: ${err}`)
      }

      try {
        this.notify_facebook(order)
      } catch (err) {
        Sentry.addBreadcrumb({
          message: '[CAUGHT] error with facebook analytics (Order)'
        });
        Sentry.captureException(err)
        // console.log(`ERR: ${err}`)
      }

      try {
        this.notify_twitter(order)
      } catch (err) {
        Sentry.addBreadcrumb({
          message: '[CAUGHT] error with twitter analytics (Order)'
        });
        Sentry.captureException(err)
        // console.log(`ERR: ${err}`)
      }

      try {
        this.notify_google(order, prices)
      } catch (err) {
        Sentry.addBreadcrumb({
          message: '[CAUGHT] error with google analytics (Order)'
        });
        Sentry.captureException(err)
        // console.log(`ERR: ${err}`)
      }
    },

    notify_intercom(order) {
      if (order.intercom_user_hash) {
        console.log('update intercom: ', order.intercom_user_hash)
        Intercom('update', { 
            email: order.email,
            // user_hash: order.intercom_user_hash 
        }) // convert this person to a known user with identity verification
        Intercom('trackEvent', 'order-completed', {
          order_id: order.id,
          total: `$${order.total}`,
          plan: 'Pre-Order',
          link: `${window.location.origin}/order/${order.uid}`
        })
      }
    },

    notify_facebook(order) {
      let _this = this
      window.cookiePrivacy.onGrant('tracking', function() {
        if (_this.isDefined('fbq')) {
          // Calculate total without tax for Facebook reporting
          const totalWithoutTax = order.total - (order.sales_tax || 0)
          fbq('track', 'Purchase', { value: totalWithoutTax, currency: 'USD' }, { eventID: order.id })
        }
      });
    },

    notify_twitter(order) {
      let _this = this
      window.cookiePrivacy.onGrant('tracking', function() {
        if (_this.isDefined('twq')) {
          twq('event', 'tw-og6m8-og6nk', {
            value: order.total,
            currency: 'USD',
            email_address: order.email,
            phone_number: _this.toE164(order.phone_number)
          });
        }
      });
    },

    notify_google(order, prices) {
      window.cookiePrivacy.onGrant('performance', function() {
        if (typeof gtag === 'undefined') return

        gtag('event', 'order completed', { event_category: 'interactions' })

        gtag('event', 'conversion', {
          send_to: 'AW-759704711/GrKUCPq0y9sYEIfZoOoC',
          value: order.total,
          currency: 'USD',
          transaction_id: order.id
        });

        const products = order.products
        const items = []

        if (products.arsenal.quantity > 0) {
          items.push({
            id: 'Arsenal 2 Standard',
            item_name: 'Arsenal 2 Standard',
            item_category: 'Arsenal',
            price: prices.arsenal_2_standard.sale,
            quantity: products.arsenal.quantity
          })
        }

        if (products.arsenal_pro.quantity > 0) {
          items.push({
            id: 'Arsenal 2 Pro',
            item_name: 'Arsenal 2 Pro',
            item_category: 'Arsenal',
            price: prices.arsenal_2_pro.sale,
            quantity: products.arsenal_pro.quantity
          })
        }

        products.arsenal.cables.forEach((cable) => {
          items.push({
            id: cable,
            item_name: cable,
            item_category: 'Cable',
            price: prices.cable.sale,
            quantity: 1
          })
        })

        products.arsenal_pro.cables.forEach((cable) => {
          items.push({
            id: cable,
            item_name: cable,
            item_category: 'Cable',
            price: prices.cable.sale,
            quantity: 1
          })
        })

        if (products.phone_mount.quantity > 0) {
          items.push({
            id: 'Phone Mount',
            item_name: 'Phone Mount',
            item_category: 'Accessory',
            price: prices.phone_mount.sale,
            quantity: products.phone_mount.quantity
          })
        }

        if (products.battery.quantity > 0) {
          items.push({
            id: 'Battery',
            item_name: 'Battery',
            item_category: 'Accessory',
            price: prices.battery.sale,
            quantity: products.battery.quantity
          })
        }

        if (products.micro_sd_card.quantity > 0) {
          items.push({
            id: 'Micro SD Card',
            item_name: 'Micro SD Card',
            item_category: 'Accessory',
            price: prices.micro_sd_card.sale,
            quantity: products.micro_sd_card.quantity
          })
        }

        gtag('event', 'purchase', {
          transaction_id: order.id,
          affiliation: 'WithArsenal',
          value: order.total,
          currency: 'USD',
          tax: order.sales_tax,
          shipping: order.shipping,
          items: items
        })
      })
    },

    isDefined(ref) {
      return typeof window[ref] !== 'undefined'
    },

    toE164(phoneNumber) {
      // Remove all non-numeric characters
      let strippedNumber = phoneNumber.replace(/\D/g, '');

      // If the number starts with '1' and has 10 more digits (total 11, including '1'), it's a US number
      if (strippedNumber.length === 11 && strippedNumber.startsWith('1')) {
        return '+' + strippedNumber;
      }

      // If the number has only 10 digits, assume it's a US number without the country code
      if (strippedNumber.length === 10) {
        return '+1' + strippedNumber;
      }

      // If none of the above, return the stripped number (this will handle numbers with explicit country codes)
      return '+' + strippedNumber;
    },
  }
}
